import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { FreeToolsFAQs } from 'pricing-pages-ui-components/frequentlyAskedQuestions/FreeToolsFAQs';
import LimitUsageSection from 'pricing-pages-ui-components/limit-usage/LimitUsageSection';
import { PageSubTitle, PageTitle } from 'pricing-pages-ui-components/semantic/PageHeader';
import { NavMarker } from 'react-rhumb';
import { getPrimaryTracker } from 'usage-tracker-container';
import ComparePlansLink from '../../../components/common/ComparePlansLink';
import IntegrationsSection from '../../../components/common/IntegrationsSection';
import PhoneSupportFooter from '../../../components/common/PhoneSupportFooter';
import { CreditsCallout } from '../../../components/common/credits-callout/CreditsCallout';
import { BannerSection } from '../../containers/BannerSection';
import { useIsFreePortal } from '../../hooks/useProductInventory';
import { FreeToolsFeatureTable } from './FreeToolsFeatureTable';
import { FreeToolsMerchCards } from './FreeToolsMerchCards';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CORE_SEATS_API_NAMES = ['hubspot-free', 'crm-suite-starter-bundle'];
export const FreeToolsPage = () => {
  const {
    isFreePortal,
    loading: isInventoryLoading
  } = useIsFreePortal();
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "FREE_TOOLS_PAGE",
    children: [/*#__PURE__*/_jsx(BannerSection, {
      screen: "crm",
      apiNames: CORE_SEATS_API_NAMES
    }), /*#__PURE__*/_jsxs(View, {
      textAlign: "center",
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsx(PageTitle, {
        "aria-level": 1,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.crm.pageTitle"
        })
      }), /*#__PURE__*/_jsx(PageSubTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.crm.description"
        })
      })]
    }), /*#__PURE__*/_jsx(FreeToolsMerchCards, {}), /*#__PURE__*/_jsx(CreditsCallout, {
      navItem: "crm"
    }), /*#__PURE__*/_jsx(ComparePlansLink, {}), /*#__PURE__*/_jsx(LimitUsageSection, {
      isFreePortal: isFreePortal && !isInventoryLoading,
      earlyRequestName: "LIMIT_USAGE",
      usageTracker: getPrimaryTracker(),
      useCompactGrid: true
    }), /*#__PURE__*/_jsx(FreeToolsFeatureTable, {}), /*#__PURE__*/_jsx(IntegrationsSection, {
      nav: "crm"
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "1400",
      children: /*#__PURE__*/_jsx(FreeToolsFAQs, {})
    }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
      phoneSourceId: "crm-footer",
      screen: "crm",
      upgradeProduct: "crm"
    })]
  });
};